import { trackContentCard } from '@portals/tracking/src/card/trackContentCard';
import { LinkTracking, TrackingContext } from '@portals/tracking/src/context/tracking';
import React, { useCallback } from 'react';

import { ContentCard as ContentCardUntracked, ContentCardVariants, Props } from './ContentCard.untracked';

export const ContentCard: React.FC<Props> = ({ node, ...rest }: Props) => {
  const handleTracking = useCallback(
    (payload: LinkTracking) => {
      trackContentCard({
        id: node.id,
        name: node.name,
        filename: node.image?.media_16x9?.name,
        ...payload,
      });
    },
    [node.id, node.image?.media_16x9?.name, node.name]
  );

  return (
    <TrackingContext.Provider value={{ trackLink: handleTracking }}>
      <ContentCardUntracked node={node} {...rest} />
    </TrackingContext.Provider>
  );
};

export type { ContentCardVariants };
